import List from '@mui/material/List';
import Collapse from '@mui/material/Collapse';

import { MenuItem } from './core/menu-item';
import { SidebarMenuItem } from './SidebarMenuItem';

export interface SidebarMenuProps {
  items: MenuItem[];
  depth: number;
  parentKey?: string;
  expandedPaths: ReadonlySet<string>;
  activePath: readonly string[];
  collapsed: boolean;
  onToggleSubmenu: (groupKey: string) => void;
  onNavigate: (item: MenuItem) => void;
}

/**
 * A chave de expansão de um item é a posição dele na árvore (`"0"`, `"2-1"`,
 * ...), não `path`/`title`: muitos itens têm `path` vazio (grupos com
 * submenu) e títulos duplicados entre nós distintos (ex.: "Relatórios"
 * aparece em mais de um contexto). Posição é sempre única e estável para uma
 * dada árvore, independente do conteúdo do item.
 */
export function SidebarMenu({
  items,
  depth,
  parentKey,
  expandedPaths,
  activePath,
  collapsed,
  onToggleSubmenu,
  onNavigate,
}: SidebarMenuProps): JSX.Element {
  return (
    <List disablePadding>
      {items.map((item, index) => {
        const groupKey = parentKey ? `${parentKey}-${index}` : `${index}`;
        const active = item.path !== '' && activePath.includes(item.path);
        const expanded = expandedPaths.has(groupKey);

        return (
          <li key={groupKey} style={{ listStyle: 'none' }}>
            <SidebarMenuItem
              item={item}
              groupKey={groupKey}
              depth={depth}
              expanded={expanded}
              active={active}
              collapsed={collapsed}
              onToggle={() => onToggleSubmenu(groupKey)}
              onNavigate={onNavigate}
            />
            {item.submenu.length > 0 && (
              <Collapse in={expanded} unmountOnExit>
                <SidebarMenu
                  items={item.submenu}
                  depth={depth + 1}
                  parentKey={groupKey}
                  expandedPaths={expandedPaths}
                  activePath={activePath}
                  collapsed={collapsed}
                  onToggleSubmenu={onToggleSubmenu}
                  onNavigate={onNavigate}
                />
              </Collapse>
            )}
          </li>
        );
      })}
    </List>
  );
}
